import Vue from 'vue'

const area = 'dashboard.cardAppointment.'
const translate = (data) => Vue.i18n.translate(data)

const needsAuthorizationContent = (data) => {
  const question = translate(area + 'needsAuthorization')
  const answer = !data?.needs_authorization
    ? translate(area + 'no')
    : translate(area + 'yes')

  return `
    <h6 class="text-uppercase grey--text">
      ${question}
    </h6>
    <p class="body-2 mb-3">
      ${answer}
    </p>
  `
}

export default needsAuthorizationContent
